import { toast } from 'sonner';
import { env } from '~/env';

// TODO: Translate errors.
export const commonActionErrorHandler = ({
  error
}: {
  error: any;
  input: any;
}) => {
  if (error?.fetchError) {
    if (env.NODE_ENV === 'development') {
      toast.error(error.fetchError);
    } else {
      toast.error('Network error. Please try again later.');
    }
    return;
  }
  if (error?.serverError) {
    toast.error(error.serverError);
    return;
  }
  if (error?.validationErrors) {
    if (env.NODE_ENV === 'development') {
      toast.error('Validation errors', {
        description: <pre className="mt-2 w-[340px] rounded-md bg-slate-950 p-4">
            <code className="text-white">{JSON.stringify(error.validationErrors, null, 2)}</code>
          </pre>
      });
    } else {
      toast.error('Internal server error.');
    }
  }
};